import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs, ref, useContext } from "@nuxtjs/composition-api";
import { useMobile } from "~/core/composables/useMobile";
import { UseExtraBalancesTypes } from "~/core/models/purchase-popup-2/UseExtraBalancesTypes";
import { UserBalance } from "~/core/models/purchase-popup-2/UserBalance";
import MunicipalityTx from "~/core/models/purchase-popup-2/MunicipalityTx";
import Web3MunicipalityTx from "~/core/models/purchase-popup-2/Web3MunicipalityTx";
import Asset from "~/pages/finances/wallet/models/Asset";

interface Props {
    userBalance: UserBalance,
    transactionObject: MunicipalityTx | Web3MunicipalityTx,
    gasFeeVisible: boolean,
    usdtAsset: Asset,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UseExtraBalance',
  props: {
    userBalance: null,
    transactionObject: null,
    gasFeeVisible: { type: Boolean, default: false },
    usdtAsset: null
  },
  emits: ['onSelectBalance'],
  setup(__props: any, { emit: $emit }) {

const props = __props as { userBalance: UserBalance, transactionObject: MunicipalityTx | Web3MunicipalityTx, gasFeeVisible: boolean, usdtAsset: Asset };

const FEE_VALUE = 3;





const {
    transactionObject,
    userBalance,
    gasFeeVisible,
    usdtAsset,
} = toRefs(props);

const { i18n } = useContext();
const isMobile = useMobile();
const selectedType = ref(null);

const isVisible = computed(() => {
    const canUse =  transactionObject.value.canUseGymnetOrUtility && (
        (transactionObject.value.priceInfo.splitAmountUtility.usdt.value + FEE_VALUE <= userBalance.value.usdt.value &&
            transactionObject.value.priceInfo.splitAmountUtility.gymnet.value <= userBalance.value.utility.value) ||
        (transactionObject.value.priceInfo.splitAmountGymnet.usdt.value + FEE_VALUE <= userBalance.value.usdt.value &&
            transactionObject.value.priceInfo.splitAmountGymnet.gymnet.value <= userBalance.value.gymnet.value))

    const visible = transactionObject.value.priceInfo.gasAmount.value > userBalance.value.bnb.value &&
        usdtAsset.value.value + FEE_VALUE > userBalance.value.usdt.value &&
        gasFeeVisible.value;

    return canUse && visible;
})

const isUtilityBalanceSufficient = computed(() => {
    return userBalance.value.utility.value >= transactionObject.value.priceInfo.splitAmountUtility.gymnet.value
        && transactionObject.value.canUseUtility;
})

const isGymnetBalanceSufficient = computed(() => {
    return userBalance.value.gymnet.value >= transactionObject.value.priceInfo.splitAmountGymnet.gymnet.value
        && transactionObject.value.canUseGymnet;
})

const getAlternativelyUsingText = computed(() => {
    const currency_yg = isUtilityBalanceSufficient.value
        ? isGymnetBalanceSufficient.value
            ? `Utility ${String(i18n.t('Or')).toLowerCase()} Gymnet`
            : 'Utility'
        : 'Gymnet';

    return i18n.t('Alternatively, you can use your CURRENCY balance to cover the gas fee.', {
        currency_yg,
    });
});

const handleSelect = async (type: UseExtraBalancesTypes) => {
    $emit('onSelectBalance', type);
    selectedType.value = type;

    if (!isUtilityBalanceSufficient.value || !isGymnetBalanceSufficient.value) {
        selectedType.value = null;
    }
}

return { __sfc: true,FEE_VALUE, $emit, props, transactionObject, userBalance, gasFeeVisible, usdtAsset, i18n, isMobile, selectedType, isVisible, isUtilityBalanceSufficient, isGymnetBalanceSufficient, getAlternativelyUsingText, handleSelect, UseExtraBalancesTypes }
}

})